// Thin, safe wrapper around Klaviyo's onsite JS (installed in public/index.html).
// That script is loaded async and does not leave a queue stub behind, so
// window.klaviyo can still be undefined when an early event fires — retry the
// same way utils/triple-whale.js does (cap ~10s) instead of dropping the event.
const send = args => {
    let attempts = 0;

    const fire = () => {
        if (window.klaviyo) {
            window.klaviyo.push(args);
            return;
        }

        if (attempts++ < 25) {
            setTimeout(fire, 400);
        }
    };

    fire();
};

export const klaviyo = (...args) => send(args);

// Klaviyo tracks Active on Site on script load only, which in an SPA means the
// landing page and nothing after it. Re-firing it per route is what keeps the
// rest of the session visible — see components/KlaviyoPageTracker.js.
//
// This only records against a profile Klaviyo already knows (one identified by a
// signup form, an email click, or an `identify` call); for an anonymous visitor
// it is a no-op, which is expected.
export const klaviyoActiveOnSite = () => send(['track', 'Active on Site']);

// Previewing a course is this site's product view, so this mirrors
// tripleWhaleProductView — same event, same id, fired from the same place.
//
// ProductID is the slug rather than the numeric course id, matching Triple Whale:
// it is what the routes and the API use, so it stays readable in reporting.
//
// URL is the course's own canonical page, not window.location.href: the modal
// opens over whatever page the visitor was on (home, curriculum, courses), and a
// Viewed Product flow needs to link back to the course, not to that page.
//
// No Price or ImageURL: courses are not sold individually, only bundled into the
// membership, so a price here would be invented, and the openCourseModal callers
// pass only slug and name. Add ImageURL if Klaviyo flows start showing the
// product — it means threading the thumbnail through those call sites.
export const klaviyoViewedProduct = ({ id, name, url }) => send(['track', 'Viewed Product', {
    ProductName: name,
    ProductID: id,
    URL: url
}]);
